var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFolderUser = function SvgIconFolderUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4.875a1.75 1.75 0 0 1 1.75-1.75h4.912a1.75 1.75 0 0 1 1.311.59h.001L12.45 6.5h7.801A1.75 1.75 0 0 1 22 8.25v1.875a1 1 0 1 1-2 0V8.5H4v10h6.556a1 1 0 1 1 0 2H3.694A1.694 1.694 0 0 1 2 18.806zM9.586 6.5l-1-1H4v1zm-.897-3h.002v1l-.004-1zm0 0h-.027z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.102 18.229a3.25 3.25 0 1 0-4.955 0 4 4 0 0 0-1.397 2.148 1 1 0 1 0 1.938.496 2 2 0 0 1 1.816-1.5 3 3 0 0 0 .242 0 2 2 0 0 1 1.817 1.5 1 1 0 0 0 1.937-.496 4 4 0 0 0-1.398-2.148m-2.477-3.354a1.25 1.25 0 0 0-.106 2.496 4 4 0 0 1 .212 0 1.25 1.25 0 0 0-.106-2.496"
  }))));
};
export default SvgIconFolderUser;